import React from 'react';
import { Box, Container, Typography, Stack, alpha, useTheme } from '@mui/material';

/**
 * Ortak iç sayfa kabuğu — dark/light + responsive.
 */
const PageShell = ({
  title,
  subtitle,
  icon,
  actions,
  children,
  maxWidth = 'lg',
  dense = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '70vh',
        pb: { xs: 4, md: 6 },
        background:
          theme.palette.mode === 'dark'
            ? `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.08)} 0%, ${theme.palette.background.default} 240px)`
            : `linear-gradient(180deg, ${alpha(theme.palette.primary.main, 0.06)} 0%, ${theme.palette.background.default} 240px)`,
      }}
    >
      <Container maxWidth={maxWidth} sx={{ pt: { xs: dense ? 2 : 3, md: dense ? 3 : 4 } }}>
        {(title || actions) && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'stretch', sm: 'flex-start' },
              justifyContent: 'space-between',
              gap: 2,
              mb: { xs: 2.5, md: 3.5 },
            }}
          >
            <Box sx={{ minWidth: 0, display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
              {icon && (
                <Box
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    flexShrink: 0,
                    display: 'grid',
                    placeItems: 'center',
                    bgcolor: alpha(theme.palette.primary.main, 0.12),
                    color: 'primary.main',
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.18)}`,
                  }}
                >
                  {icon}
                </Box>
              )}
              <Box sx={{ minWidth: 0 }}>
                {title && (
                  <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                      fontWeight: 800,
                      fontSize: { xs: '1.45rem', md: '1.85rem' },
                      letterSpacing: -0.3,
                      lineHeight: 1.2,
                    }}
                  >
                    {title}
                  </Typography>
                )}
                {subtitle && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.6 }}>
                    {subtitle}
                  </Typography>
                )}
              </Box>
            </Box>

            {actions && (
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                useFlexGap
                sx={{ alignItems: 'center', justifyContent: { xs: 'flex-start', sm: 'flex-end' } }}
              >
                {actions}
              </Stack>
            )}
          </Box>
        )}
        {children}
      </Container>
    </Box>
  );
};

export const SurfaceCard = ({ children, sx = {}, ...props }) => {
  const theme = useTheme();
  return (
    <Box
      {...props}
      sx={{
        bgcolor: 'background.paper',
        borderRadius: 3,
        border: `1px solid ${alpha(theme.palette.divider, theme.palette.mode === 'dark' ? 0.9 : 1)}`,
        boxShadow:
          theme.palette.mode === 'dark'
            ? '0 8px 24px rgba(0,0,0,0.25)'
            : '0 8px 24px rgba(15,23,42,0.04)',
        overflow: 'hidden',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

export default PageShell;
